/**
 * Amount Formatter Utilities
 * 금액 포맷팅 관련 유틸리티 함수
 */
import { formatCurrency } from '@/shared/utils/formatter';

/**
 * 입력값에서 숫자만 추출하여 천단위 콤마 포맷으로 변환
 * @param value 입력 문자열
 * @returns 천단위 콤마가 적용된 문자열
 */
export const formatAmountInput = (value: string): string => {
    const numericValue = value.replace(/[^0-9]/g, '');
    return numericValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

/**
 * 숫자를 한국 원화 형식으로 포맷팅 (null/undefined는 '0' 반환)
 * @param value 숫자 값
 * @returns 천단위 콤마가 적용된 문자열
 */
export const formatAmount = (value: number | null | undefined): string => {
    if (value === null || value === undefined) return '0';
    return formatCurrency(value);
};

/**
 * 콤마가 포함된 문자열에서 숫자만 추출
 * @param value 콤마가 포함된 문자열
 * @returns 숫자 값
 */
export const parseAmountString = (value: string): number => {
    const numericValue = value.replace(/[^0-9]/g, '');
    return parseInt(numericValue, 10) || 0;
};

/**
 * 금액 유효성 검사 (0보다 큰지)
 * @param value 검사할 값 (문자열 또는 숫자)
 * @returns 유효한 금액인지 여부
 */
export const isValidAmount = (value: string | number): boolean => {
    const numericValue = typeof value === 'string'
        ? parseAmountString(value)
        : value;
    return numericValue > 0;
};
